import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { AddToBasketButton } from 'components'
import { trackAddToCartEvent } from 'utils/tagManager'

import styles from './productBlockButtons.css'

const propTypes = {
  sku: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  price: PropTypes.shape({
    retail: PropTypes.string,
    discounted: PropTypes.string,
    discountedLoyalty: PropTypes.string
  }).isRequired,
  category: PropTypes.array.isRequired,
  availability: PropTypes.oneOf([
    'instock',
    'outofstock',
    'loyaltycard_required',
    'unavailable'
  ]).isRequired,
  availableAsPackage: PropTypes.shape({
    uom: PropTypes.string,
    qos: PropTypes.number
  }),
  isArticle: PropTypes.bool.isRequired,
  isAvailableAsItem: PropTypes.bool.isRequired,
  isBeverage: PropTypes.bool.isRequired
}

class ProductBlockButtons extends Component {
  shouldComponentUpdate (nextProps) {
    return Object.keys(propTypes)
      .some((prop) => nextProps[prop] !== this.props[prop])
  }

  renderNotAvailable (label) {
    return (
      <span className={styles.notAvailable}>
        <span className={styles.label}>{label}</span>
      </span>
    )
  }

  renderButtonItem () {
    const {availableAsPackage, sku, title, price, category} = this.props
    const quantity = 1
    const label = 'Fles'
    return (
      <AddToBasketButton
        className={styles.button}
        baseClassName={'primaryButton'}
        sku={sku}
        quantity={quantity}
        inline={!!availableAsPackage.qos}
        size={'small'}
        {...trackAddToCartEvent(title, sku, price, category, quantity, label)}
      >
        {label}
      </AddToBasketButton>
    )
  }

  renderButtonBox () {
    const {sku, availableAsPackage, isAvailableAsItem, title, price, category} = this.props
    const quantity = availableAsPackage.qos
    const label = availableAsPackage.uom
    return (
      <AddToBasketButton
        className={styles.button}
        baseClassName={'secondaryButton'}
        sku={sku}
        quantity={quantity}
        inline={isAvailableAsItem}
        size={'small'}
        {...trackAddToCartEvent(title, sku, price, category, quantity, label)}
      >
        {`${label} (${quantity})`}
      </AddToBasketButton>
    )
  }

  renderButtonArticle () {
    const {sku, title, price, category} = this.props
    const quantity = 1
    const label = 'Artikel'
    return (
      <AddToBasketButton
        baseClassName={'primaryButtonBlock'}
        sku={sku}
        quantity={quantity}
        size={'small'}
        {...trackAddToCartEvent(title, sku, price, category, quantity, label)}
      >
        {label}
      </AddToBasketButton>
    )
  }

  render () {
    const {
      availability,
      availableAsPackage,
      isArticle,
      isAvailableAsItem,
      isBeverage
    } = this.props
    let leftButton
    let rightButton

    if (availability === 'outofstock') {
      leftButton = this.renderNotAvailable('Tijdelijk uitverkocht')
    } else if (availability === 'unavailable') {
      leftButton = this.renderNotAvailable('Niet meer beschikbaar')
    } else if (isBeverage) {
      if (isAvailableAsItem) {
        leftButton = this.renderButtonItem()
      }
      if (availableAsPackage.qos) {
        rightButton = this.renderButtonBox()
      }
    } else if (isArticle) {
      leftButton = this.renderButtonArticle()
    }

    return (
      <div className={styles.wrapper}>
        {leftButton}
        {rightButton}
      </div>
    )
  }
}

ProductBlockButtons.propTypes = propTypes

ProductBlockButtons.defaultProps = {
  availableAsPackage: {
    uom: '',
    qos: null
  }
}

export default ProductBlockButtons
